import { Box } from '@jfs/ui-new'
import parse from 'html-react-parser'
import React, { useCallback, useEffect, useRef } from 'react'
import { isIE } from '../../utils'
import { Modal } from '../Modal'

interface InjectIframeProps {
  onUrlChange: (url: string) => void
  htmlScript: string
  show: boolean
  theme: any
}

export const InjectIframe = ({ onUrlChange, htmlScript, show, theme }: InjectIframeProps) => {
  const iframeRef: any = useRef(null)
  useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.onload = () => {
        try {
          let loadedUrl = iframeRef.current.contentWindow.location.href
          onUrlChange(loadedUrl)
        } catch (err) {}
      }
    }
  }, [onUrlChange])

  const replace = useCallback((node: any) => {
    if (node.type === 'script') {
      const script: any = document.createElement('script')
      const keys: any = node.attribs.keys
      for (const key in keys) {
        script[key] = node.attribs[key]
      }
      script.innerHTML = node?.children[0]?.data
      setTimeout(() => {
        document.body.appendChild(script)
        window.onload && window.onload()
      }, 300)
      return null
    }
    if (node.name === 'iframe') {
      node.attribs.ref = iframeRef
    }
    if (node.attribs) {
      node.attribs.style = 'height: 100%;width: 100%;'
    }
    return node
  }, [])

  const options = { replace }
  if (!show) {
    return null
  }

  return (
    <Modal
      type="BottomTopFull"
      show={show}
      isFullWidth={true}
      theme={theme}
      containerTopPadding={isIE() ? 5 : undefined}>
      <Box width={'100%'} height="100%" backgroundColor={theme?.bodyBgColor} zIndex={9999}>
        {parse(htmlScript, options)}
      </Box>
    </Modal>
  )
}
